import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  CLIENT_GET_REQUESTING,
  CLIENT_GET_ERROR,
  CLIENT_GET_SUCCESS,
  CLIENT_GET_RANKING_SUCCESS,
  CLIENT_GET_RANKING_REQUESTING
} from "./constants";

import {
  MANAGER_GET_DASHBOARD_REQUESTING,
  MANAGER_GET_DASHBOARD_SUCCESS
} from "../manager/constants";

import { fetchApi } from "../api";
import { getBestActionsRequest, setBestActions } from "../action/actions";

const getMostDoneActions = allActions => {
  const result = {
    leadership: {
      title: "",
      action: "",
      rating: 0,
      count: 0,
      donePercentage: 0
    },
    resilience: {
      rating: 0,
      count: 0,
      donePercentage: 0
    },
    proactivity: {
      rating: 0,
      donePercent: 0,
      count: 0
    },
    publicSpeaking: {
      rating: 0,
      donePercentage: 0,
      count: 0
    },
    teamCohesion: {
      rating: 0,
      donePercentage: 0,
      count: 0
    }
  };

  const counts = [];
  allActions.forEach(el => {
    const actionIndex = counts.findIndex(
      element => element.action === el.action
    );
    if (actionIndex > -1) {
      counts[actionIndex].count += 1;
      counts[actionIndex].rating += el.rating || 0;
      counts[actionIndex].donePercentage += el.donePercentage || 0;
      counts[actionIndex].category = el.category;
    } else {
      counts.push({
        action: el.action,
        donePercentage: el.donePercentage || 0,
        count: 1,
        rating: el.rating || 0,
        category: el.category
      });
    }
  });
  const orderArray = counts.sort((a, b) => b.count - a.count);
  let i = 0;
  let count = 0;
  while (i < orderArray.length && count < 5) {
    if (result[orderArray[i].category].count <= 0) {
      result[orderArray[i].category].count = orderArray[i].count;
      result[orderArray[i].category].donePercentage =
        orderArray[i].donePercentage;
      result[orderArray[i].category].rating = orderArray[i].rating;
      result[orderArray[i].category].action = orderArray[i].action;
      count++;
    }
    i++;
  }

  return result;
};

const getBestActions = allActions => {
  const result = {
    leadership: {
      title: "",
      action: "",
      rating: 0
    },
    resilience: {
      rating: 0
    },
    proactivity: {
      rating: 0
    },
    publicSpeaking: {
      rating: 0
    },
    teamCohesion: {
      rating: 0
    }
  };

  allActions.forEach(el => {
    if (result[el.category].rating < el.rating) {
      result[el.category].rating = el.rating;
      result[el.category].action = el.action;
    }
  });

  return result;
};

const apiEndpoints = {
  getClient: "/v1/clients/get-dashboard",
  getDashboardManager: "/v1/clients/get-dashboard-manager",
  create: "/v1/clients/",
  // getRanking: "/v1/teams/",
  getTeamRanking: "/v1/teams/get-ranking/dashboard",
  getUserRanking: "/v1/users/get-user-ranking"
};

const getTeamRankingApi = data => {
  return fetchApi(apiEndpoints.getTeamRanking, data, "post");
};

const getUserRankingApi = data => {
  return fetchApi(apiEndpoints.getUserRanking, data, "post");
};

const getClientApi = data => {
  return fetchApi(apiEndpoints.getClient, data, "post");
};

const getDashboardManagerApi = data => {
  return fetchApi(apiEndpoints.getDashboardManager, data, "post");
};

function* getClientFlow(action) {
  try {
    const client = yield call(getClientApi, action.payload);
    yield put({ type: CLIENT_GET_SUCCESS, payload: client });
    yield call(getRankingFlow, { payload: action.payload });

    // for the initial structure - not optimal ...
    const mostDoneActions = getMostDoneActions(client.allActions);
    yield put(setBestActions(mostDoneActions));
    // api calls
    yield put(getBestActionsRequest(mostDoneActions));
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "Something went wrong";
    }
    yield put({ type: CLIENT_GET_ERROR, payload: message });
  }
}

function* getDashboardManagerFlow(action) {
  try {
    const client = yield call(getDashboardManagerApi, action.payload);
    yield put({ type: CLIENT_GET_SUCCESS, payload: client });
    yield put({ type: MANAGER_GET_DASHBOARD_SUCCESS, payload: {} });
    yield call(getRankingFlow, { payload: action.payload });

    // for the initial structure - not optimal ...
    const mostDoneActions = getMostDoneActions(client.allActions);
    yield put(setBestActions(mostDoneActions));
    // api calls
    yield put(getBestActionsRequest(mostDoneActions));
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "Something went wrong";
    }
    yield put({ type: CLIENT_GET_ERROR, payload: message });
  }
}

function* getRankingFlow(action) {
  try {
    const { userId, clientId } = action.payload;
    const [userRanking, teamRanking] = yield all([
      call(getUserRankingApi, action.payload),
      call(getTeamRankingApi, action.payload)
    ]);
    yield put({
      type: CLIENT_GET_RANKING_SUCCESS,
      payload: { userRanking: userRanking.slice(0, 10), teamRanking }
    });
  } catch (error) {
    console.log(error);
  }
}

function* Saga() {
  yield all([
    takeLatest(CLIENT_GET_REQUESTING, getClientFlow),
    takeLatest(MANAGER_GET_DASHBOARD_REQUESTING, getDashboardManagerFlow)
    // takeLatest(CLIENT_GET_RANKING_REQUESTING, getRankingFlow)
  ]);
}

export default Saga;
